//IMPORTAR NUESTRA CONSTANTE

import {BASE_API} from "../utils/constants";

export async function loginApi(formValue){

    try {
        //PASO 1 crear const url
        const url = `${BASE_API}/api/auth/login/`
        
        //PASO 2: parametros
        const params = {
            method: 'POST',
            headers: {
              "Content-type": "application/json"
            },
            body: JSON.stringify(formValue),
        };

     //PASO 3: RESPUESTA:
        const response = await fetch(url, params);
        
        if(response.status !== 200){
            throw new Error ("Usuario y contrasela Incorrectos")
        }
    
        //PASO 4: RESULTADO
    
        const result = await response.json();

        return result;


    } catch (error) {
        throw error;
    }


}


export async function getMeApi(token){
    //LOG ERRORES: Error al poner la ruta api y no cerrar. Error en escribir Authorization
    try {
        //PASO 1
        const url = `${BASE_API}/api/auth/me/`;

        //PASO 2
        const params = {
            headers:  {
                Authorization: `Bearer ${token}`
            }
        }
        //PASO 3
        const response = await fetch(url, params);

        //PASO 4
        const result = await response.json();

        //PASO 5
        return result;
        
    } catch (error) {
        console.log(error)
    }
}


export async function getUsersApi(token){

    //PASO 1: url 2: params - headers - Authorization - Bearer - token 3. response - fetch url - params - await json()
    const url = `${BASE_API}/api/users/`;

    const params = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    //FALLAMOS FALTO EL AWAIT
    const response = await fetch(url, params);

    try {

        const result = await response.json();
        return result;

    } catch (error) {

        throw error;

    }
    

}

export async function addUserApi(data, token){
    try {
        const url = `${BASE_API}/api/users/`;
        const params = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json"
            },
            body: JSON.stringify(data)
        }

        const response = await fetch (url, params);

        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }
}


export async function userEditApi(id, data, token ){
    
    try {
        
        const url = `${BASE_API}/api/users/${id}/`

        const params = {
            method: 'PATCH',
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-type": "application/json"
            },
            body: JSON.stringify(data)
        }

        const response = await fetch(url, params);

        const result = await response.json();

        return result

    } catch (error) {
        throw error
    }
}


export async function userDeleteApi(id, token){

    try {
        const url = `${BASE_API}/api/users/${id}/`;
        const params = {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json"
              }
        }

        const response = await fetch(url, params);

        const result = await response.json();

        return result

    } catch (error) {
        throw error;
    }


}